import { api } from 'utils/redux/apiThunks'
import handleErrors from 'utils/redux/errorsHandling'
import {reset} from 'redux-form'

// ------------------------------------
// Constants
// ------------------------------------
export const SENT_MESSAGE = 'SENT_MESSAGE'

// ------------------------------------
// Thunk
// ------------------------------------

export function sentMessage ( payload ) {
	return {
		type: SENT_MESSAGE,
		contactForm: payload
	}
}

export function sendMessage (data = {}) {
	return dispatch => {
		return api.post('contactform', { body: data })
			.then(response => response.json())
			.then(res => handleErrors(res))
			.then(res => {
				if(res.status === 'success') {
					dispatch(reset('contactForm'))
					return dispatch(sentMessage({
						sentMessage: true,
						successMsg: 'Вашето съобщение беше изпратено успешно.'
					}))
				}
			})
	}
}

export function resetFormMsg () {
	return dispatch => dispatch(sentMessage({
		sentMessage: null,
		successMsg: null
	}))
}
